export const dataAttr = {
  SIZE: 'data-size',
  SHAPE: 'data-shape',
} as const;

export const sizes = {
  TINY: 'tiny',
  SMALL: 'small',
  LARGE: 'large',
  PORTRAIT: 'portrait',
  CINEMA: 'cinema',
} as const;

export const shapes = {
  CIRCLE: 'circle',
  RECTANGULAR: 'rectangular',
} as const;
